<template>
  <div class="wo-inner-container">
    <div class="color-picker-wrapper">
      <v-color-picker
        v-model="color"
        showSwatches
        hideInputs
        :swatches="swatches"
        style="width: 100%;"
        @input="updateColor"
      />
    </div>
  </div>
</template>

<script>

export default {
    name: 'ColorPicker',
    data() {
        return {
            color: '#000000',
            swatches: [
                ['#FF0000', '#AA0000', '#550000'],
                ['#FFFF00', '#AAAA00', '#555500'],
                ['#00FF00', '#00AA00', '#005500'],
                ['#00FFFF', '#00AAAA', '#005555'],
                ['#0000FF', '#0000AA', '#000055'],
            ],
        };
    },
    methods: {
        updateColor(newColor) {
            this.$emit('sendData', newColor);
        },
    },
};
</script>


<style scoped>
.color-picker-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
::v-deep .v-color-picker {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

::v-deep .v-color-picker__canvas {
  width: 100% !important;
  height: 150px !important;
  max-width: none !important;
}
::v-deep .v-color-picker__canvas canvas {
  width: 100% !important;
  height: 100% !important;
}

</style>
